// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__2OXhA","card":"Cards_card__3Alo5","infected":"Cards_infected__1TOrY","recoverd":"Cards_recoverd__3oPmE","dead":"Cards_dead__1biUy"};